const es = {
    nav: {
        servicios: "Servicios",
        sobre: "Sobre nosotros",
        zona: "Zona de servicio",
        faq: "FAQ",
        contacto: "Contacto",
        reserva: "Reserva tu servicio",
        openMenu: "Abrir menú",
        closeMenu: "Cerrar menú",
    },
    hero: {
        eyebrow: "Servicios para perros · Maresme",
        l1: "El bienestar",
        l2: "de tu perro,",
        l3: "cerca de casa.",
        sub: "Servicios para perros en el Maresme, con atención personalizada, confianza y mucho amor por lo que hacemos.",
        cta1: "Reserva tu servicio",
        cta2: "Conócenos",
        pills: ["Trato personalizado", "Fotos durante el servicio", "De Alella a Mataró"],
        cardTitle: "Maresme, Barcelona",
        cardSub: "Costa · Montaña · Mediterráneo",
        imgAlt: "Mauro, el bulldog francés de Irene, de paseo otoñal",
    },
    marquee: { b: "Cercano · Profesional · Mediterráneo" },
    home: {
        servicesEyebrow: "Servicios",
        servicesTitle: "Todo lo que tu perro necesita",
        servicesSub: "Paseos, cuidado, alojamiento y mucho más, siempre con atención personalizada y en tu zona.",
        viewAll: "Ver todos los servicios →",
        faqEyebrow: "Preguntas frecuentes",
        faqTitle: "Antes de escribirnos, quizá te ayude esto",
        faqViewAll: "Ver todas las preguntas →",
    },
    services: {
        "paseos": {
            nombre: "Paseos para perros",
            tagline: "Mar, montaña y ritmo canino.",
            desc: "Paseos por los caminos, playas y senderos del Maresme, adaptados a la edad, la energía y el carácter de tu perro.",
            incluye: [
                "Paseo individual o en grupo reducido",
                "Ruta adaptada a la energía y edad de tu perro",
                "Agua fresca y pausas a la sombra",
                "Resumen con fotos al terminar cada paseo",
            ],
            paraQuien: "Para perros que necesitan gastar energía, sociabilizar o simplemente disfrutar de un buen paseo cuando tu jornada no lo permite.",
            duracion: "30, 60 o 90 min por paseo",
            chip: "desde 12 €",
            tarifas: [["Paseo 30 min", "12 €"], ["Paseo 60 min", "17 €"], ["Paseo 90 min", "24 €"]],
            faqs: [
                { q: "¿Mi perro paseará solo o con más perros?", a: "Depende de su carácter y de lo que acordemos en el primer encuentro. Priorizamos siempre su comodidad y seguridad." },
                { q: "¿Qué pasa si llueve o hace mucho calor?", a: "Adaptamos horarios y rutas a la climatología. En verano evitamos las horas centrales del día." },
            ],
        },
        "dog-sitting": {
            nombre: "Dog sitting",
            tagline: "Compañía y cuidado por horas.",
            desc: "Acompañamiento y cuidado de tu perro por horas: una tarde, una noche o ese evento al que no puede acompañarte.",
            incluye: [
                "Compañía y supervisión constante durante las horas acordadas",
                "Paseo, juego y alimentación según su rutina",
                "Actualizaciones con fotos durante el servicio",
                "En tu domicilio o en el nuestro",
            ],
            paraQuien: "Para quienes necesitan cubrir horas concretas: una cena, un evento, una jornada larga o una escapada de un día.",
            duracion: "Por horas, según necesidad",
            chip: "A consultar",
            tarifas: null,
            faqs: [
                { q: "¿Hay un mínimo de horas?", a: "Trabajamos con bloques flexibles. Cuéntanos tu caso y lo vemos juntos." },
            ],
        },
        "cuidado-a-domicilio": {
            nombre: "Cuidado a domicilio",
            tagline: "Tu perro, en su casa, con su rutina.",
            desc: "Nos desplazamos a tu hogar mientras estás fuera, para que tu perro mantenga sus costumbres en el entorno que mejor conoce.",
            incluye: [
                "Cuidado en tu domicilio durante tu ausencia",
                "Paseos, comida, agua y juego siguiendo su rutina",
                "Administración de medicación si es necesaria",
                "Comunicación diaria con fotos y novedades",
            ],
            paraQuien: "Para perros que se estresan fuera de casa, seniors o hogares donde la rutina lo es todo.",
            duracion: "Desde un día hasta estancias largas",
            chip: "A consultar",
            tarifas: null,
            faqs: [
                { q: "¿Os quedáis a dormir en casa o hacéis visitas?", a: "Ambas opciones son posibles según lo que tu perro necesite. Lo definimos juntos antes de reservar." },
            ],
        },
        "guarderia": {
            nombre: "Guardería de día",
            tagline: "Su día, bien aprovechado.",
            desc: "Cuidado diurno con juego, descanso y paseos, para que tu perro no pase el día solo mientras trabajas.",
            incluye: [
                "Jornada diurna de cuidado y compañía",
                "Paseos y tiempo de juego supervisado",
                "Momentos de descanso en un entorno tranquilo",
                "Resumen del día con fotos",
            ],
            paraQuien: "Para perros sociables que pasan muchas horas solos entre semana y necesitan actividad y compañía.",
            duracion: "Media jornada o jornada completa",
            chip: "desde 22 €/día",
            tarifas: [["Guardería de día", "22 €/día"], ["Guardería premium", "28 €/día"]],
            faqs: [
                { q: "¿Cuántos perros hay a la vez?", a: "Trabajamos con grupos muy reducidos para garantizar atención real a cada perro." },
                { q: "¿Qué incluye la guardería premium?", a: "Una jornada con atención extra: más paseos, juego individual y mimos adicionales. Consúltanos los detalles." },
            ],
        },
        "alojamiento": {
            nombre: "Alojamiento",
            tagline: "Un hogar cuando tú no estás.",
            desc: "Tu perro se queda en un entorno hogareño, sin jaulas, con la atención y el cariño de una casa de familia.",
            incluye: [
                "Estancia en ambiente familiar, sin jaulas",
                "Paseos diarios incluidos",
                "Rutina de comidas y descanso respetada",
                "Fotos y novedades cada día",
            ],
            paraQuien: "Para vacaciones, viajes de trabajo o cualquier ausencia en la que quieras que tu perro esté como en casa.",
            duracion: "Por noches, fines de semana o estancias largas",
            chip: "desde 29 €/noche",
            tarifas: [["Alojamiento", "29 €/noche"], ["Alojamiento premium", "35 €/noche"]],
            faqs: [
                { q: "¿Puedo conocer el lugar antes de reservar?", a: "Sí. Antes de cualquier estancia organizamos un encuentro para conoceros y resolver dudas." },
            ],
        },
        "visitas-a-domicilio": {
            nombre: "Visitas a domicilio",
            tagline: "Una visita justo cuando la necesita.",
            desc: "Visitas puntuales a tu casa para dar de comer, renovar el agua, un paseo corto o administrar medicación.",
            incluye: [
                "Comida, agua fresca y revisión del entorno",
                "Paseo corto o tiempo de juego",
                "Administración de medicación si la necesita",
                "Confirmación con foto tras cada visita",
            ],
            paraQuien: "Para cachorros que aún no aguantan muchas horas, perros senior o días puntuales complicados.",
            duracion: "Visitas de 30 o 60 min",
            chip: "desde 16 €",
            tarifas: [["Visita 30 min", "16 €"], ["Visita 60 min", "22 €"]],
            faqs: [
                { q: "¿Cuántas visitas al día podéis hacer?", a: "Las que tu perro necesite. Lo habitual es de una a tres, según el caso." },
            ],
        },
        "transporte": {
            nombre: "Transporte para mascotas",
            tagline: "Le llevamos, con seguridad.",
            desc: "Traslados en vehículo adaptado por el Maresme: veterinario, peluquería o cualquier cita a la que no puedas llevarle.",
            incluye: [
                "Vehículo acondicionado para el transporte de perros",
                "Recogida y entrega puerta a puerta",
                "Acompañamiento durante la cita si lo necesitas",
                "Confirmación de llegada en tiempo real",
            ],
            paraQuien: "Para quienes no disponen de coche, no pueden ausentarse del trabajo o necesitan un traslado puntual.",
            duracion: "Trayectos puntuales o de ida y vuelta",
            chip: "desde 10 €",
            tarifas: [["Trayecto puntual (Dog Taxi)", "desde 10 €"]],
            faqs: [
                { q: "¿Cubrís trayectos fuera del Maresme?", a: "Nuestro foco es el Maresme, pero cuéntanos el trayecto y lo valoramos." },
            ],
        },
        "personalizado": {
            nombre: "Servicios personalizados",
            tagline: "Cuéntanos qué necesita tu perro.",
            desc: "Cada perro es un mundo. Si lo que necesitas no encaja en ningún servicio, lo hablamos y diseñamos algo a medida.",
            incluye: [
                "Escuchamos tu caso sin compromiso",
                "Propuesta adaptada a tu perro y a tu rutina",
                "Combinación de servicios si hace falta",
                "Presupuesto claro antes de empezar",
            ],
            paraQuien: "Para necesidades especiales, horarios complicados o situaciones que requieren una solución a medida.",
            duracion: "A definir según el caso",
            chip: "A consultar",
            tarifas: null,
            faqs: [
                { q: "¿Qué tipo de cosas podéis valorar?", a: "Desde acompañamiento en mudanzas hasta rutinas para perros con necesidades especiales. Escríbenos y lo hablamos." },
            ],
        },
    },
    detail: {
        inicio: "Inicio",
        servicios: "Servicios",
        reservar: "Reservar",
        incluye: "Qué incluye",
        paraQuien: "Para quién es",
        duracion: "Duración",
        precio: "Precio",
        aConsultar: "A consultar",
        aConsultarText: "Cuéntanos tu caso y te daremos un presupuesto claro y sin compromiso, adaptado al servicio y a tu perro.",
        notas: ["Festivos: +20%", "Segundo perro: +30–50%, según servicio"],
        comoReservar: "Cómo reservar",
        pasos: [
            "Escríbenos por el formulario o WhatsApp contándonos qué necesitas.",
            "Organizamos un primer encuentro para conocer a tu perro, sin compromiso.",
            "Confirmamos el servicio y el presupuesto, y empezamos cuando quieras.",
        ],
        primerTitle: "Primer encuentro sin compromiso",
        primerText: "Antes de cualquier servicio, nos conocemos en persona. Tu perro manda.",
        faqTitle: "Preguntas sobre",
        hablamos: "¿Hablamos de",
        hablamosText: "Cuéntanos cómo es tu perro y qué necesitas. Te responderemos con una propuesta clara y sin compromiso.",
        enMaresme: "en el Maresme",
    },
    trust: {
        eyebrow: "Por qué elegirnos",
        title: "Confianza que se demuestra, no que se promete",
        sub: "Sabemos lo que significa dejar a tu perro en manos de otra persona. Por eso trabajamos así.",
        items: [
            { title: "Atención personalizada", desc: "Pocos perros a la vez y un trato pensado para cada carácter. Nada de cadenas de montaje." },
            { title: "Comunicación durante el servicio", desc: "Fotos y novedades mientras cuidamos de tu perro, para que tú también estés tranquilo." },
            { title: "Experiencia con perros", desc: "Tratamos cada perro con la calma y el respeto que nos gustaría para el nuestro." },
            { title: "Conocimiento del Maresme", desc: "Vivimos aquí: conocemos los senderos, las sombras de verano y los rincones tranquilos." },
            { title: "Protocolos claros", desc: "Primer encuentro previo, información detallada de tu perro y acuerdos por escrito." },
            { title: "Transparencia en precios", desc: "Tarifas claras y presupuesto antes de empezar, sin sorpresas ni letra pequeña." },
        ],
    },
    areaHome: {
        eyebrow: "Zona de servicio",
        title: "Del Maresme, para el Maresme",
        sub: "No somos una empresa más de Barcelona: vivimos y trabajamos aquí. Paseamos por sus senderos, conocemos sus playas y cuidamos perros de Alella a Mataró.",
        p: "Si buscas un paseador de perros, un cuidador o un dog sitter en el Maresme que conozca de verdad la zona, estás en el lugar adecuado.",
        cta: "Ver todos los municipios",
    },
    map: { sea: "Mar Mediterráneo", mountains: "Serralada Litoral", around: "y alrededores" },
    steps: {
        eyebrow: "Cómo funciona",
        title: "Cuatro pasos y mucha tranquilidad",
        items: [
            { num: "01", title: "Contacta con nosotros", desc: "Rellena el formulario o escríbenos por WhatsApp contándonos qué necesita tu perro." },
            { num: "02", title: "Conocemos a tu perro", desc: "Primer encuentro sin compromiso para conoceros, resolver dudas y entender su carácter y rutinas." },
            { num: "03", title: "Elegimos el servicio adecuado", desc: "Te proponemos el servicio y el plan que mejor encaja, con un presupuesto claro." },
            { num: "04", title: "Tu perro disfruta, tú descansas", desc: "Nos ocupamos de todo y te mantenemos al día con fotos y novedades." },
        ],
    },
    testi: {
        eyebrow: "Testimonios",
        title: "Lo que dicen nuestros perros (bueno, sus familias)",
        sub: "Las primeras familias que confían en nosotros lo cuentan mejor que nosotros.",
        items: [
            { text: "Dejar a Yugus con Irene fue la mejor decisión. Después de cada paseo nos llegaban fotos y un resumen que nos hacía sentir que estábamos allí. Se nota que quiere a los perros de verdad.", author: "Laura", dog: "con Yugus" },
            { text: "Tina es mayor y muy de su rutina, e Irene lo entendió desde el primer encuentro. Volver a casa y encontrarla tranquila y feliz no tiene precio.", author: "Alba", dog: "con Tina" },
        ],
        pending: "El próximo testimonio puede ser el de tu perro",
    },
    faqs: [
        { q: "¿Cómo reservo un servicio?", a: "Rellena el formulario de contacto o escríbenos por WhatsApp. Te responderemos para conocer a tu perro y concretar el servicio, sin ningún compromiso." },
        { q: "¿Cuánto cuestan los servicios?", a: "Paseos desde 12 € (30 min), visitas a domicilio desde 16 €, guardería 22 €/día, alojamiento 29 €/noche y Dog Taxi desde 10 €. Festivos +20% y segundo perro +30–50% según servicio. Siempre te confirmamos el precio exacto antes de reservar." },
        { q: "¿Puedo cancelar o modificar una reserva?", a: "Política de cancelación en definición. La publicaremos aquí en cuanto esté confirmada. (editable)" },
        { q: "¿Qué ocurre durante el primer encuentro?", a: "Nos conocemos en persona, tu perro se familiariza con nosotros y recopilamos toda la información necesaria: rutinas, carácter, salud y manías. Es gratuito y sin compromiso." },
        { q: "¿Qué información necesitáis sobre mi perro?", a: "Edad, raza, carácter, rutinas de comida y paseo, salud, medicación si la toma, sociabilidad con otros perros y cualquier detalle que te parezca importante." },
        { q: "¿En qué zonas trabajáis?", a: "En todo el Maresme: Alella, El Masnou, Premià de Mar, Premià de Dalt, Vilassar de Mar, Vilassar de Dalt, Cabrils, Argentona, Mataró y alrededores. Si estás cerca, consúltanos." },
        { q: "¿Tenéis disponibilidad en fines de semana y festivos?", a: "Sí, también trabajamos fines de semana y festivos (con un suplemento del 20% en festivos). Consúltanos las fechas que necesitas." },
        { q: "¿Ofrecéis servicios personalizados?", a: "Sí. Si tu perro tiene necesidades especiales o tu caso no encaja en un servicio estándar, cuéntanoslo y diseñamos una solución a medida." },
        { q: "¿Qué pasa si hay una emergencia?", a: "En el primer encuentro recopilamos los datos de tu veterinario de referencia y un contacto de emergencia, para saber exactamente cómo actuar si hiciera falta." },
        { q: "¿Atendéis perros con necesidades especiales?", a: "Sí, valoramos cada caso de forma individual en el primer encuentro para asegurarnos de poder ofrecer el cuidado adecuado." },
    ],
    contact: {
        whatsappMsg: "Hola, me gustaría información sobre los servicios de Maresme Dog Care.",
        eyebrow: "Reservas y contacto",
        title: "Cuéntanos qué necesita tu perro",
        sub: "Rellena el formulario y te responderemos muy pronto para conoceros, resolver dudas y preparar un presupuesto sin compromiso.",
        note: "También puedes escribirnos directamente por WhatsApp si lo prefieres. Sin compromiso y con toda la calma del mundo.",
        form: {
            nombre: "Tu nombre *", nombrePh: "María García",
            email: "Email *", emailPh: "maria@email.com",
            telefono: "Teléfono", telefonoPh: "600 123 456",
            municipio: "Municipio *", municipioPh: "Elige tu municipio", otro: "Otro / cercano",
            perro: "Nombre de tu perro *", perroPh: "Mauro",
            edad: "Edad de tu perro", edadPh: "3 años",
            servicio: "Servicio que necesitas *", servicioPh: "Elige un servicio", servicioOtro: "Otro / no lo tengo claro",
            fechas: "Fechas aproximadas", fechasPh: "Del 12 al 18 de agosto",
            mensaje: "Mensaje", mensajePh: "Cuéntanos cómo es tu perro, su rutina y qué necesitas…",
            submit: "Cuéntanos qué necesita tu perro",
            sending: "Enviando…",
            privacy: "Sin compromiso. Solo usaremos tus datos para responderte.",
            toastOk: "Solicitud enviada. ¡Gracias!",
            toastErr: "No se ha podido enviar. Inténtalo de nuevo o escríbenos por WhatsApp.",
        },
        success: {
            title: "Hemos recibido tu mensaje",
            text1: "Gracias por escribirnos. Te contactaremos muy pronto para conocer a",
            text2: "y ver qué necesita.",
            reset: "Enviar otra solicitud",
        },
    },
    contactPage: {
        whatsapp: "WhatsApp", email: "Email", instagram: "Instagram",
        zona: "Zona", zonaValue: "Todo el Maresme, Barcelona",
    },
    footer: {
        tagline: "Servicios para perros en el Maresme. Cercanos, profesionales y con mucho amor por lo que hacemos.",
        servicios: "Servicios", nosotros: "Nosotros", legal: "Legal",
        verTodos: "Ver todos →",
        sobre: "Sobre nosotros", zona: "Zona de servicio", faq: "Preguntas frecuentes", contacto: "Contacto y reservas",
        aviso: "Aviso legal", privacidad: "Política de privacidad", cookies: "Cookies",
        claim: "El bienestar de tu perro, cerca de casa.",
    },
    servicesPage: {
        eyebrow: "Servicios para perros en el Maresme",
        title: "Servicios pensados para cada perro",
        sub: "Del paseo diario al alojamiento durante tus vacaciones. Todos nuestros servicios empiezan igual: conociendo a tu perro.",
        ctaEyebrow: "¿Empezamos?",
        ctaTitle: "Cuéntanos qué necesitas",
        ctaSub: "Sin compromiso. Te responderemos para conocer a tu perro y preparar un presupuesto claro.",
    },
    about: {
        eyebrow: "Sobre nosotros",
        title: "Hola, soy Irene",
        p1a: "Me llamo",
        p1b: "y he compartido mi vida con perros desde siempre. También colaboro como voluntaria en protectoras y organizo eventos y actividades relacionadas con el mundo canino.",
        p2: "De esa pasión nace Maresme Dog Care: la voluntad de crear en esta comarca unos servicios pensados desde el cariño, la experiencia y el respeto por cada perro, entendiendo que cada uno tiene su propia personalidad, necesidades y forma de disfrutar.",
        p3: "Vivo en el Maresme y lo disfruto cada día: sus caminos entre viñedos, sus playas de madrugada, la sierra cuando aprieta el calor. Y casi siempre con Mauro, mi bulldog francés y compañero de aventuras.",
        caption: "Irene y Mauro, compañeros de aventuras",
        galleryEyebrow: "La vida con perros",
        galleryTitle: "Así se ve un día cualquiera",
        gallery: ["Verano en el Mediterráneo, con Mauro", "Otoño entre castaños", "Ni la nieve nos para", "Mauro, siempre explorando"],
        blocks: [
            { title: "Nuestra filosofía", text: "Pocos perros, mucha atención. Preferimos decir que no antes que ofrecer un cuidado que no sea excelente. Cada perro es único y merece un plan a su medida." },
            { title: "Compromiso con el bienestar", text: "El bienestar de tu perro guía cada decisión: rutinas respetadas, rutas adaptadas, descanso cuando lo necesita y comunicación constante contigo." },
            { title: "Experiencia de la vida real", text: "La nuestra no viene de un folleto: viene de años compartidos con perros, del voluntariado en protectoras y de organizar actividades del mundo canino. Perros de todo tipo, carácter y energía." },
        ],
        ctaLine: "¿Nos conocemos? El primer café (y la primera olfateada) invitan nosotros.",
        cta: "Cuéntanos qué necesita tu perro",
    },
    areaPage: {
        eyebrow: "Zona de servicio",
        title: "Servicios para perros en el Maresme",
        sub: "Cubrimos toda la comarca del Maresme, de la costa a la sierra. Si vives aquí (o tienes tu segunda residencia), cuidamos de tu perro cerca de casa.",
        h2: "Paseadores y cuidadores de perros que conocen el territorio",
        p1: "El Maresme no es solo nuestra zona de trabajo: es nuestra casa. Conocemos los senderos de la Serralada Litoral para los perros con más energía, las horas buenas para bajar a la playa en verano y los rincones tranquilos para los que prefieren calma.",
        p2a: "Si buscas un",
        p2b: "paseador de perros en el Maresme",
        p2c: "un",
        p2d: "dog sitter de confianza",
        p2e: "o",
        p2f: "cuidado de perros a domicilio",
        p2g: "aquí estamos: cerca, disponibles y con un trato que empieza siempre por conocer a tu perro.",
        municipiosTitle: "Municipios donde trabajamos",
        line1: "Cuidado de perros en",
        other: "¿Vives en otro municipio cercano? Escríbenos: si podemos llegar bien, llegamos.",
        ctaTitle: "Tu perro, en buenas manos y cerca de casa",
        ctaSub: "Cuéntanos en qué municipio estás y qué necesita tu perro. Te responderemos con una propuesta sin compromiso.",
        cta: "Reserva tu servicio",
    },
    faqPage: {
        eyebrow: "Preguntas frecuentes",
        title: "Dudas resueltas, sin rodeos",
        sub: "Reservas, precios, cancelaciones, primeros encuentros y todo lo que sueles preguntarte antes de confiarnos a tu perro.",
        noAnswer: "¿No encuentras tu respuesta?",
        cta: "Escríbenos directamente",
    },
    cookie: {
        text: "Usamos cookies técnicas y de análisis para mejorar tu experiencia. Puedes aceptarlas o rechazarlas cuando quieras.",
        accept: "Aceptar",
        reject: "Rechazar",
        more: "Más información",
    },
    welcome: {
        title: "¡Qué alegría verte de nuevo!",
        text: "Seguimos por aquí, de Alella a Mataró, para lo que tu perro necesite.",
        close: "Cerrar",
    },
    legal: {
        updated: "Última actualización: septiembre de 2026",
        aviso: {
            title: "Aviso legal",
            sections: [
                { h: "1. Titular del sitio web", p: "En cumplimiento de la Ley 34/2002, de Servicios de la Sociedad de la Información y de Comercio Electrónico (LSSI-CE), se informa de que este sitio web es titularidad de Irene Infante Riol, con NIF 39403930P, domicilio en Carrer Romaní 19, 08348 Cabrils (Barcelona) y correo electrónico de contacto ireneinfanteriol@gmail.com." },
                { h: "2. Objeto", p: "Este sitio web tiene por objeto informar sobre los servicios de cuidado y bienestar para perros que Maresme Dog Care ofrece en la comarca del Maresme (Barcelona), así como facilitar un canal de contacto para solicitar información o presupuestos." },
                { h: "3. Condiciones de uso", p: "El acceso y uso de este sitio web atribuye la condición de usuario e implica la aceptación de este aviso legal. El usuario se compromete a hacer un uso lícito, diligente y respetuoso de los contenidos. El titular no se responsabiliza del mal uso que se realice de los contenidos ni de los daños derivados de ello." },
                { h: "4. Propiedad intelectual", p: "Todos los contenidos de este sitio web (textos, fotografías, diseño, logotipo y código) son titularidad de Irene Infante Riol o se utilizan con licencia, y están protegidos por la normativa de propiedad intelectual. Queda prohibida su reproducción, distribución o comunicación pública sin autorización expresa." },
                { h: "5. Responsabilidad y enlaces", p: "El titular no se hace responsable de los contenidos de sitios web de terceros enlazados desde esta página, ni garantiza la ausencia de errores o la disponibilidad continua del sitio, aunque trabajará para evitarlos y subsanarlos." },
                { h: "6. Legislación aplicable", p: "Este aviso legal se rige por la legislación española. Para cualquier controversia, las partes se someten a los juzgados y tribunales del domicilio del usuario, salvo que la normativa aplicable disponga otra cosa." },
            ],
        },
        privacidad: {
            title: "Política de privacidad",
            sections: [
                { h: "1. Responsable del tratamiento", p: "El responsable del tratamiento de tus datos personales es Irene Infante Riol, con NIF 39403930P, domicilio en Carrer Romaní 19, 08348 Cabrils (Barcelona) y correo electrónico ireneinfanteriol@gmail.com." },
                { h: "2. Datos que recogemos y finalidad", p: "A través del formulario de contacto recogemos tu nombre, correo electrónico, teléfono, municipio y la información que nos facilitas sobre tu perro y el servicio que necesitas. Estos datos se utilizan únicamente para responder a tu solicitud, contactar contigo y preparar un presupuesto o propuesta de servicio." },
                { h: "3. Base jurídica", p: "La base legal para el tratamiento es tu consentimiento, otorgado al enviar el formulario, y la aplicación de medidas precontractuales solicitadas por ti al pedirnos información o presupuesto (art. 6.1.a y 6.1.b del RGPD)." },
                { h: "4. Conservación y destinatarios", p: "Los datos se conservan durante el tiempo necesario para atender tu solicitud y, en su caso, la relación de servicio. No se ceden a terceros ni se utilizan con fines publicitarios. El envío de notificaciones por correo electrónico se realiza a través de un proveedor técnico que actúa como encargado del tratamiento." },
                { h: "5. Tus derechos", p: "Puedes ejercer en cualquier momento tus derechos de acceso, rectificación, supresión, oposición, limitación y portabilidad escribiendo a ireneinfanteriol@gmail.com. Si consideras que el tratamiento no se ajusta a la normativa, puedes presentar una reclamación ante la Agencia Española de Protección de Datos (www.aepd.es)." },
                { h: "6. Seguridad", p: "Aplicamos medidas técnicas y organizativas apropiadas para proteger tus datos personales frente a accesos no autorizados, pérdida o alteración." },
            ],
        },
        cookies: {
            title: "Política de cookies",
            sections: [
                { h: "1. Qué son las cookies", p: "Las cookies son pequeños archivos que se almacenan en tu dispositivo al visitar un sitio web y que permiten, entre otras cosas, recordar tus preferencias o analizar cómo se utiliza la página." },
                { h: "2. Cookies que utiliza este sitio", p: "Este sitio web utiliza cookies técnicas necesarias para su correcto funcionamiento y cookies de análisis que nos ayudan a entender cómo se usa la página y mejorarla. Al entrar verás un aviso donde puedes aceptarlas o rechazarlas; si las rechazas, la analítica queda desactivada. No utilizamos cookies publicitarias." },
                { h: "3. Cómo gestionar las cookies", p: "Además del aviso de esta web, puedes permitir, bloquear o eliminar las cookies desde la configuración de tu navegador. Ten en cuenta que bloquear las cookies técnicas puede afectar al funcionamiento de la web. Consulta la ayuda de tu navegador (Chrome, Safari, Firefox, Edge) para más detalles." },
                { h: "4. Actualizaciones", p: "Esta política puede actualizarse para reflejar cambios en las cookies utilizadas. Para cualquier duda, escríbenos a ireneinfanteriol@gmail.com." },
            ],
        },
    },
};

export default es;
